import { createContext, ReactNode, useContext, useReducer } from 'react';
import {
  appContextReducer,
  Dispatch,
  INITIAL_CONTEXT,
  State,
} from '@Comments/context/appReducer';

const AppContext = createContext<State>(INITIAL_CONTEXT);
const AppDispatchContext = createContext<Dispatch | undefined>(undefined);

type Props = {
  children: ReactNode;
  value: Pick<State, 'env' | 'commentsCount'>;
};

export const AppContextProvider = ({ children, value }: Props) => {
  const initialContext = value
    ? { ...INITIAL_CONTEXT, ...value }
    : INITIAL_CONTEXT;
  const [context, dispatch] = useReducer(appContextReducer, initialContext);

  return (
    <AppContext.Provider value={context}>
      <AppDispatchContext.Provider value={dispatch}>
        {children}
      </AppDispatchContext.Provider>
    </AppContext.Provider>
  );
};

export const useAppDispatcher = () => {
  const context = useContext(AppDispatchContext);
  if (context === undefined) {
    throw new Error('useAppDispatcher must be used within a AppProvider');
  }
  return context;
};

export const useAppContext = () => {
  const state = useContext(AppContext);
  if (state === undefined) {
    throw new Error('useAppContext must be used within a AppProvider');
  }
  return state;
};
